export default "__VITE_ASSET__25Ok5Doa__"